import Plyr from 'plyr';
import scrollLock from './scrollLock';
import bus from '../util/eventBus';

const videoLightbox = () => {
  const lightboxTrigger = document.querySelectorAll('.u-video-lightbox');
  let lightbox;
  let player;

  const buildLightbox = () => {
    lightbox = document.createElement('div');
    lightbox.classList.add('c-lightbox');
    const closeBtn = document.createElement('button');
    closeBtn.innerHTML =
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15.556 15.556"><g fill="none" stroke="#fff" stroke-linecap="round" stroke-width="2"><path d="M14.142 1.414L1.414 14.142"/><path d="M14.142 14.142L1.414 1.414"/></g></svg>';
    closeBtn.classList.add('c-btn', 'c-btn--is-icon', 'c-lightbox__close');
    lightbox.appendChild(closeBtn);
    document.body.appendChild(lightbox);

    const closeThis = () => {
      lightbox.classList.remove('is-active');
      scrollLock.unlock('.c-header');
      player.destroy();
      lightbox.removeChild(lightbox.lastChild);
    };

    lightbox.addEventListener('click', function(e) {
      if (e.target !== this) return;
      closeThis();
    });

    closeBtn.addEventListener('click', () => closeThis());

    return lightbox;
  };

  if (lightboxTrigger) {
    buildLightbox();

    lightboxTrigger.forEach(e => {
      const addPlayer = playerEl => {
        player = new Plyr(playerEl, {
          controls:
            '<div class="plyr__controls c-video__controls"><button type="button" class="plyr__control c-video__control" aria-label="Play, {title}" data-plyr="play"><svg class="icon--pressed" role="presentation"><use xlink:href="#icon-pause"></use></svg><svg class="icon--not-pressed" role="presentation"><use xlink:href="#icon-play"></use></svg><span class="label--pressed plyr__tooltip" role="tooltip">Pause</span><span class="label--not-pressed plyr__tooltip" role="tooltip">Play</span></button><div class="c-video__controls-meta"><div class="c-video__controls-inner"><div class="plyr__progress c-video__progress"><input data-plyr="seek" type="range" min="0" max="100" step="0.01" value="0" aria-label="Seek"><progress class="plyr__progress__buffer" min="0" max="100" value="0">% buffered</progress><span role="tooltip" class="plyr__tooltip">00:00</span></div><div class="plyr__time plyr__time--current c-video__time c-video__time--current" aria-label="Current time">00:00</div><div class="plyr__time plyr__time--duration c-video__time c-video__time--duration" aria-label="Duration">00:00</div></div></div></div>',
          loadSprite: false,
        });
      };
      const trigger = e;
      const { lightboxSource, lightboxHref, lightboxMime } = trigger.dataset;

      trigger.addEventListener('click', () => {
        lightbox.classList.add('is-active');
        scrollLock.lock('.c-header');

        const videoPlayerEl = document.createElement('div');
        let videoEl;

        videoPlayerEl.classList.add('c-video', 'c-lightbox__video');

        if (lightboxSource === 'self') {
          videoEl = document.createElement('video');
          const videoSourceEl = document.createElement('source');
          const attrs = ['playsinline', 'controls'];
          attrs.forEach(attr => videoEl.setAttribute(attr, ''));
          videoSourceEl.setAttribute('src', lightboxHref);
          videoSourceEl.setAttribute('type', lightboxMime);
          videoEl.appendChild(videoSourceEl);
        } else {
          videoEl = document.createElement('div');
          videoEl.setAttribute('data-plyr-provider', lightboxSource);
          videoEl.setAttribute('data-plyr-embed-id', lightboxHref);
        }

        videoEl.classList.add('c-video__el');

        videoPlayerEl.appendChild(videoEl);
        lightbox.appendChild(videoPlayerEl);

        addPlayer(videoPlayerEl.querySelector('.c-video__el'));
      });
    });
  }
};

videoLightbox();

bus.on('ewg-facet-filtering', () => videoLightbox());



// WEBPACK FOOTER //
// ./src/scripts/modules/videoLightbox.js